import CertificateContent from '@layouts/Settings/Certificates'
import * as React from 'react'
import { useIntl } from 'react-intl'
import Layout from '../../layouts/Settings/Layout'
import { useSelector } from 'react-redux'
import { StoreProps } from '@interfaces/StoreState'
import StudentProfile from '@classes/StudentProfile'

const CertificatePage: React.FC = () => {
  const intl = useIntl()
  const profile = useSelector(({ userProfile }: StoreProps) => userProfile.info)
  const student = new StudentProfile(profile?.StudentProfile?.StudentProfileInfo)

  return (
    <Layout
      title={intl.formatMessage({ id: 'Manage my account' })}
      activeMainNav="Learning"
      activeSubNavGroup={1}
      activeSubNav={student.OnlyOnDemand ? 2 : 4}
    >
      <CertificateContent />
    </Layout>
  )
}

export default CertificatePage
